import { GoDotFill, GoPlus } from "react-icons/go";
import { Button, InputField } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import useLeaveHook from "../../../../hooks/useLeaveHook";

import { Fragment, useEffect, useState } from "react";
import { FaCalendar } from "react-icons/fa";
import { BsPersonCheck, BsPersonFillDash } from "react-icons/bs";
import { Menu, Transition } from "@headlessui/react";
import { CiCirclePlus, CiEdit } from "react-icons/ci";
import { FiFileMinus, FiTarget } from "react-icons/fi";
import { IoMdEye, IoMdMore } from "react-icons/io";
import {
  MdCancel,
  MdDelete,
  MdOutlineCancel,
  MdOutlineInfo,
} from "react-icons/md";
import { LuUser } from "react-icons/lu";
import usePositionHook from "../../../../hooks/usePositionHook";
import useDepartmentHook from "../../../../hooks/useDepartmentHook";
import { useStateSetter } from "../../../../hooks/statehooks/UseStateSettersHook";
import { useForm } from "react-hook-form";
import MiniAppraisalTemplateItem from "../../../../components/Modules/Appraisal/MiniAppraisalTemplateItem";
import useGoalsHook from "../../../../hooks/useGoalsHook";
import { onGetOrgTemplateAppr } from "../../../../services/appraisal";
import { useStateGetter } from "../../../../hooks/statehooks/UseStateGettersHook";
import useAppraisalTempHook from "../../../../hooks/useAppraisalTempHook";
import useEmployeeHook from "../../../../hooks/useEmployeeHook";
import EmployeeItem from "../EmployeeItem";
import useAppraisalHook from "../../../../hooks/useAppraisalHook";
import { Stats } from "fs";
import { toast } from "react-toastify";
import SubmitAppraisalModal from "../../../../components/Modules/Appraisal/SubmitAppraisalModal";

export default ({
  setshowaddleavemodal,
  isAdminview,
  appraisals,
  refresh,
}: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No appraisal</p>
      <small>No appraisal</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" /> Add appraisal
          </>
        }
        onBtnClick={() => {
          setshowaddleavemodal(true);
        }}
      />
    </div>
  );

  const { authuser } = useStateGetter();

  return (
    <div className="w-full  ">
      <div className="">
        {appraisals.length > 0 ? (
          <div className="grid grid-cols-2 gap-2">


        {/* Display appraisal for line manager to take manager's Feedback */}

            {authuser.isEmployee
              ? appraisals.map((item: any) => (
                  <AppraisalItem item={item} refresh={refresh} />
                ))
              : appraisals.map((item: any) => (
                  <AppraisalItem2 item={item} refresh={refresh} />
                ))}
          </div>
        ) : (
          <EmptyList />
        )}
      </div>
    </div>
  );
};
// For Line managers
 const AppraisalItem = ({ item, refresh }: any) => {
   const { showModal, setShowModal, setLoading } = useStateSetter();
   const [enddate, setenddate] = useState("");
   const { config } = useStateGetter();
   const { control, getValues } = useForm();
   const { getOrgTemplates, orgAppTemplates } = useAppraisalTempHook();
   const [goals, setgoals] = useState<any[]>([]);
   const { SelectedOrg } = useStateGetter();
   const [emp, setemp] = useState<any>({});
   const { allorgPositions } = usePositionHook();
   const { selectedOrgEmployees } = useEmployeeHook();
   const { UpdateAppraisal } = useAppraisalHook();
   const { selectedOrgDepts } = useDepartmentHook();
   useEffect(() => {
     var enddate_ = new Date(item.deadlineDate);
 
     setenddate(enddate_.toDateString());
   }, []);
 
   useEffect(() => {
     if (item.target == "employee") {
       setemp(
         selectedOrgEmployees.filter(
           (k: any, key: number) => k.id == item.employeeID
         )[0]
       );
     }
   }, [selectedOrgEmployees]);
 
   const gettempgoals = async () => {
     var res = await onGetOrgTemplateAppr(item.templateID, config);
     setgoals(res.data);
   };
 
   useEffect(() => {
     gettempgoals();
   }, [item.templateID]);
 
   const RejectApprModal = () => {
     return (
       <div className="flex flex-col justify-center w-full items-center">
         <MdOutlineInfo size={30} className="text-primary my-2" />
 
         <p className="font-semibold"> Reject Leave Request </p>
         <small className="font-light text-gray-500   text-center">
           You are about to reject this leave request. Please leave a note
           explaining the reason for the rejection.
         </small>
         <div className="w-full">
           <InputField
             name="reason"
             title="Reason"
             placeholder={"Reason for rejection"}
             isTextArea
             control={control}
           />
         </div>
 
         <div className=" gap-6 w-full flex ">
           <Button
             outlined
             disabled={false}
             text="Cancel"
             onBtnClick={() => {
               setShowModal(false);
             }}
           />
           <Button disabled={false} text="Reject" onBtnClick={async () => {}} />
         </div>
       </div>
     );
   };
 
   const GoalItem = ({ item }) => (
     <div className="border border-1 flex justify-between text-textbg border-gray-200 py-1 px-2 rounded-[8px] bg-white">
       <div>
         {" "}
         <p className="font-semibold text-sm ">{item.title}</p>
         <p className="text-xs font-light">{item.desc}</p>
         <p className="text-xs font-semiboldx">
           <FaCalendar className="inline mr-1" />
           {new Date(item.date).toDateString()}
         </p>
       </div>
     </div>
   );
 
   const ViewApprModal = () => {
     return (
       <div className="flex flex-col justify-start w-full items-star ">
         <p className="font-semibold w-full flex justify-between text-sm">
           {item.title}
           <MdOutlineCancel
             onClick={() => setShowModal(false)}
             size={20}
             className="text-gray-400"
           />
         </p>
         <p className="text-sm w-full my-2">
           {" "}
           <GoDotFill
             size={15}
             className={`${
               item.status.includes("Pending") || item.status.includes("Cancel")
                 ? "text-[#F79009]"
                 : ""
             }  ${item.status.includes("In-Progress") ? "text-blue-400" : ""}  ${
               item.status.includes("Completed") ? "text-green-400" : ""
             } inline `}
           />
           {item.status}
         </p>
 
         <div className="flex mt-2 flex-col  w-full">
           {item.target == "employee" && (
             <div className="flex">
               <LuUser
                 className="  p-2 rounded-full bg-faintBlue  text-textbg"
                 size={50}
               />
               <div className="m-2  ">
                 <p className="font-semibold text-sm">
                   {emp?.firstName} {emp?.lastName}
                 </p>
                 <p className="font-light text-xs">{emp?.workEmail} </p>
                 <p className="font-light   ">
                   <span className="bg-faint text-xs mx-1 rounded">
                     {
                       allorgPositions.filter(
                         (ik: any) => ik.id == emp?.positionID
                       )[0]?.positionTitle
                     }
                   </span>
                   <span className="bg-faint text-xs mx-1 rounded">
                     {
                       selectedOrgDepts.filter(
                         (ik: any) => ik.id == emp?.deptID
                       )[0]?.deptName
                     }
                   </span>
                 </p>
               </div>
             </div>
           )}
 
           <div className="p-3 bg-gray-100 px-4 w-full rounded">
             <p className="w-full flex justify-between text-xs">
               <span className="font-medium ">Appraisal type</span>
               <span className="font-medium capitalize">{item.target}</span>
             </p>
             <p className="w-full flex justify-between text-xs">
               <span className="font-medium ">Expiry Date</span>
               <span className="font-medium">{todatestring(enddate)}</span>
             </p>
           </div>
           <div>
             <div className="flex w-full justify-between items-center">
               <p className="  font-bold mt-2 text-sm "> Goals</p>
             </div>
 
             <div className="grid grid-cols-2 gap-4">
               {goals.map((ik: any, key: number) => (
                 <GoalItem key={key} item={ik} />
               ))}
             </div>
           </div>
           {item.target == "employee" ? (
             <div>
               <p className="text-sm font-bold mt-2 ">Feedback form</p>
 
               <div className="grid grid-cols-2 gap-2 ">
                 <MiniAppraisalTemplateItem
                   refresh={getOrgTemplates}
                   item={{
                     ...orgAppTemplates.filter((kl: any) =>
                       kl.name
                         .toLowerCase()
                         .includes("Employee Feedback".toLowerCase())
                     )[0],
                     name: "Self Assessment Form",
                   }}
                 />
                 <MiniAppraisalTemplateItem
                   refresh={getOrgTemplates}
                   item={{
                     ...orgAppTemplates.filter((kl: any) =>
                       kl.name
                         .toLowerCase()
                         .includes("Manager Feedback".toLowerCase())
                     )[0],
                     name: "Manager Feedback Form",
                   }}
                 />
               </div>
             </div>
           ) : (
             <div className=" grid grid-cols-2 gap-2 py-4 max-h-[200px] overflow-y-scroll  ">
               {/* list of affected employess */}
             </div>
           )}
           {
             <div className="gap-6 w-full flex">
               <Button
                 text="Manager Feedback Form"
                 onBtnClick={async () => {
                   setLoading(true);
                   try {
                     var res = await UpdateAppraisal(item.id, {
                       status: "In-Progress"
                     });
                   } catch (e: any) {
                     toast.error(e);
                   } finally {
                     setLoading(false);
                     setShowModal(false);
                     refresh();
 
                     showModal(  "",  "",  "",  <SubmitAppraisalModal
                         show={setShowModal}
                         appraisal={item}
                         item={{
                          ...orgAppTemplates.filter((kl: any) =>
                            kl.name
                              .toLowerCase()
                              .includes("Manager Feedback".toLowerCase())
                          )[0],
                          name: "Manager Feedback Form",
                        }}
                       />  );
                   }
                 }}
               />
             </div>
           }
         </div>
       </div>
     );
   };
 
   return (
     <div className=" px-2 py-4  rounded-[10px] border border-gray-300  flex justify-between ">
       <div>
         <p className="font-semibold text-bluegray700 ">{item.title}</p>
         <p className=" flex text-sm font-light">
           {/* names of employess */}
           {item.target == "organization" && (
             <>
               {selectedOrgEmployees
                 .filter((k: any, key: number) => key < 2)
                 .map((item: any, key: number) => (
                   <span>
                     {" "}
                     {` ${item?.firstName}  ${item.lastName}  ${
                       key != 1 ? " , " : " + "
                     }`}
                   </span>
                 ))}
               {` ${
                 selectedOrgEmployees.length > 2
                   ? selectedOrgEmployees.length - 2
                   : ""
               } Others`}
             </>
           )}
           {item.target == "position" && (
             <>
               {selectedOrgEmployees
                 .filter(
                   (k: any, key: number) => k.positionID == item.positionID
                 )
                 .filter((i: any, key: number) => key < 2)
                 .map((item: any, key: number) => (
                   <span>
                     {` ${item?.firstName}  ${item.lastName}  ${
                       key != 1 ? ", " : " + "
                     }`}
                   </span>
                 ))}
               {` ${
                 selectedOrgEmployees.length > 2
                   ? selectedOrgEmployees.length - 2
                   : ""
               } Others`}
             </>
           )}
           {item.target == "dept" && (
             <>
               {selectedOrgEmployees
                 .filter((k: any, key: number) => k.deptID == item.deptID)
                 .filter((i: any, key: number) => key < 2)
                 .map((item: any, key: number) => (
                   <span>
                     {` ${item?.firstName}  ${item?.lastName}  ${
                       key < 1 ? ", " : " + "
                     }`}
                   </span>
                 ))}
               {` ${
                 selectedOrgEmployees.length > 2
                   ? selectedOrgEmployees.length - 2
                   : ""
               } Others `}
             </>
           )}
           {item.target == "employee" && (
             <>
               {selectedOrgEmployees
                 .filter((k: any, key: number) => k.id == item.employeeID)
                 .map((item: any, key: number) => (
                   <span> {` ${item?.firstName}  ${item.lastName}`}</span>
                 ))}
             </>
           )}
         </p>
         <div className="flex text-bluegray700 justify-center items-center ">
           <p className="text-xs font-light">
             <FaCalendar
               size={15}
               className="inline   bg-bluegray700 text-white p-1 rounded "
             />
             {new Date(item.deadlineDate).toDateString()}
           </p>
           <p className="text-xs  capitalize font-light">
             <BsPersonCheck
               size={15}
               className="inline m-1 bg-bluegray700 text-white p-.5 rounded "
             />
             {item.target}
           </p>
           <p className="text-xs font-light ">
             <GoDotFill
               size={15}
               className={`${
                 item.status.includes("Pending") ||
                 item.status.includes("Cancel")
                   ? "text-[#F79009]"
                   : ""
               }  ${
                 item.status.includes("In-Progress") ? "text-blue-400" : ""
               }  ${
                 item.status.includes("Completed") ? "text-green-400" : ""
               } inline `}
             />
             {item.status}
           </p>
         </div>
       </div>
       <Menu as="div" className={`relative my-2 `}>
         <Menu.Button className="   w-full  ">
           <IoMdMore size={20} className="text-textbg " />
         </Menu.Button>
         <Transition
           as={Fragment}
           enter="transition ease-out duration-100"
           enterFrom="transform opacity-0 scale-95"
           enterTo="transform opacity-100 scale-100"
           leave="transition ease-in duration-75"
           leaveFrom="transform opacity-100 scale-100"
           leaveTo="transform opacity-0 scale-95"
         >
           <Menu.Items
             onClick={() => {}}
             className="origin-top-left z-10 absolute right-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
           >
             <Menu.Item>
               <p
                 onClick={() => {
                   showModal("", "", <> </>, <ViewApprModal />);
                 }}
                 className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
               >
                 <IoMdEye className="inline" /> View
               </p>
             </Menu.Item>
           </Menu.Items>
         </Transition>
       </Menu>
     </div>
   );
 };

const todatestring = (datestring: string) => {
  var date = new Date(datestring);

  return date.toDateString();
};

const AppraisalItem2 = ({ item, refresh }: any) => {
  const [startdate, setstartdate] = useState("");
  const { showModal, setShowModal, setLoading } = useStateSetter();
  const [enddate, setenddate] = useState("");
  const { config } = useStateGetter();
  const { control, getValues } = useForm();
  const { getOrgTemplates, orgAppTemplates } = useAppraisalTempHook();
  const [goals, setgoals] = useState<any[]>([]);
  const { SelectedOrg } = useStateGetter();
  const [emp, setemp] = useState<any>({});
  const { allorgPositions } = usePositionHook();
  const { selectedOrgEmployees } = useEmployeeHook();

  const { UpdateAppraisal } = useAppraisalHook();

  const { selectedOrgDepts } = useDepartmentHook();
  useEffect(() => {
    var enddate_ = new Date(item.deadlineDate);
    setenddate(enddate_.toDateString());
  }, []);

  useEffect(() => {
    if (item.target == "employee") {
      setemp(
        selectedOrgEmployees.filter(
          (k: any, key: number) => k.id == item.employeeID
        )[0]
      );
    }
  }, [selectedOrgEmployees]);

  const gettempgoals = async () => {
    var res = await onGetOrgTemplateAppr(item.templateID, config);
    setgoals(res.data);


    
  };

  useEffect(() => {
    gettempgoals();
  }, [item]);

  function getduration() {
    var date1 = new Date(item.startDate);
    var date2 = new Date(item.endDate);

    const timeDifference = date2.getTime() - date1.getTime(); // Difference in milliseconds
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24); // Convert to day
    return Math.round(daysDifference);
  }

  const RejectApprModal = () => {
    return (
      <div className="flex flex-col justify-center w-full items-center">
        <MdOutlineInfo size={30} className="text-primary my-2" />

        <p className="font-semibold"> Reject Appraisal </p>
        <small className="font-light text-gray-500   text-center">
          You are about to reject employee appraisal
        </small>
        <div className="w-full">
          <InputField
            name="reason"
            title="Reason"
            placeholder={"Reason for rejection"}
            isTextArea
            control={control}
          />
        </div>

        <div className=" gap-6 w-full flex ">
          <Button
            outlined
            disabled={false}
            text="Cancel"
            onBtnClick={() => {
              setShowModal(false);
            }}
          />
          <Button
            disabled={false}
            text="Reject"
            onBtnClick={async () => {
              setLoading(true);
              try {
                var res = await UpdateAppraisal(item.id, {
                  status: "Cancel",
                });
              } catch (e: any) {
                toast.error(e);
              } finally {
                setLoading(false);
                setShowModal(false);
                refresh();
              }
            }}
          />
        </div>
      </div>
    );
  };

  const GoalItem = ({ item }) => (
    <div className="border border-1 flex justify-between text-textbg border-gray-200 py-1 px-2 rounded-[8px] bg-white">
      <div>
        {" "}
        <p className="font-semibold text-sm ">{item.title}</p>
        <p className="text-xs font-light">{item.desc}</p>
        <p className="text-xs font-semiboldx">
          <FaCalendar className="inline mr-1" />
          {new Date(item.date).toDateString()}
        </p>
      </div>
    </div>
  );

  const ViewApprModal = () => {
    return (
      <div className="flex flex-col justify-start w-full items-star ">
        <p className="font-semibold w-full flex justify-between text-sm">
          {item.title}
          <MdOutlineCancel
            onClick={() => setShowModal(false)}
            size={20}
            className="text-gray-400"
          />
        </p>
        <p className="text-sm w-full my-2">
          {" "}
          <GoDotFill
            size={15}
            className={`${
              item.status.includes("Pending") || item.status.includes("Cancel")
                ? "text-[#F79009]"
                : ""
            }  ${item.status.includes("In-Progress") ? "text-blue-400" : ""}  ${
              item.status.includes("Completed") ? "text-green-400" : ""
            } inline `}
          />
          {item.status}
        </p>

        <div className="flex mt-2 flex-col  w-full">
          {item.target == "employee" && (
            <div className="flex">
              <LuUser
                className="  p-2 rounded-full bg-faintBlue  text-textbg"
                size={50}
              />
              <div className="m-2  ">
                <p className="font-semibold text-sm">
                  {emp?.firstName} {emp?.lastName}
                </p>
                <p className="font-light text-xs">{emp?.workEmail} </p>
                <p className="font-light   ">
                  <span className="bg-faint text-xs mx-1 rounded">
                    {
                      allorgPositions.filter(
                        (ik: any) => ik.id == emp?.positionID
                      )[0]?.positionTitle
                    }
                  </span>

                  <span className="bg-faint text-xs mx-1 rounded">
                    {
                      selectedOrgDepts.filter(
                        (ik: any) => ik.id == emp?.deptID
                      )[0]?.deptName
                    }
                  </span>
                </p>
              </div>
            </div>
          )}

          <div className="p-3 bg-gray-100 px-4 w-full rounded">
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Appraisal type</span>
              <span className="font-medium capitalize">{item.target}</span>
            </p>
            <p className="w-full flex justify-between text-xs">
              <span className="font-medium ">Expiry Date</span>
              <span className="font-medium">{todatestring(enddate)}</span>
            </p>
          </div>
          <div>
            <div className="flex w-full justify-between items-center">
              <p className="  font-bold mt-2 text-sm "> Goals</p>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {goals.filter((item)=>item.templateID).map((ik: any, key: number) => (
                <GoalItem key={key} item={ik} />
              ))}

              
            </div>
          </div>
          {item.target == "employee" ? (
            <div>
              <p className="text-sm font-bold mt-2 ">Feedback form</p>

              <div className="grid grid-cols-2 gap-2 ">
                <MiniAppraisalTemplateItem
                  refresh={getOrgTemplates}
                  item={{
                    ...orgAppTemplates.filter((kl: any) =>
                      kl.name
                        .toLowerCase()
                        .includes("Employee Feedback".toLowerCase())
                    )[0],
                    name: "Self Assessment Form",
                  }}
                />
                <MiniAppraisalTemplateItem
                  refresh={getOrgTemplates}
                  item={{
                    ...orgAppTemplates.filter((kl: any) =>
                      kl.name
                        .toLowerCase()
                        .includes("Manager Feedback".toLowerCase())
                    )[0],
                    name: "Manager Feedback Form",
                  }}
                />
              </div>
            </div>
          ) : (
            <div>
              <p className="  font-bold mt-2 text-sm "> Participants</p>
              <div className=" grid grid-cols-2 gap-2 py-4 max-h-[200px] overflow-y-scroll  ">
                {/* list of affected employess */}

                {item.target == "organization" && (
                  <>
                    {selectedOrgEmployees
                      .filter((k: any, key: number) => key < 2)
                      .map((i: any, key) => (
                        <EmployeeItem key={key} item={i} />
                      ))}
                  </>
                )}
                {item.target == "position" && (
                  <>
                    {selectedOrgEmployees
                      .filter(
                        (k: any, key: number) => k.positionID == item.positionID
                      )
                      .filter((i: any, key: number) => key < 2)
                      .map((i: any, key) => (
                        <EmployeeItem key={key} item={i} />
                      ))}
                  </>
                )}
                {item.target == "dept" && (
                  <>
                    {selectedOrgEmployees
                      .filter((k: any, key: number) => k.deptID == item.deptID)
                      .filter((i: any, key: number) => key < 2)
                      .map((i: any, key) => (
                        <EmployeeItem key={key} item={i} />
                      ))}
                  </>
                )}

                {selectedOrgEmployees.map((i: any) => (
                  <EmployeeItem item={i} />
                ))}
              </div>
            </div>
          )}
          {
            <div className="   gap-6 w-full flex ">
              <Button
                outlined
                disabled={false}
                text="Reject"
                onBtnClick={async () => {
                  showModal("", "", <></>, <RejectApprModal />);
                }}
              />
              <Button
                disabled={false}
                text="Approve"
                onBtnClick={async () => {
                  setLoading(true);
                  try {
                    var res = await UpdateAppraisal(item.id, {
                      status: "Completed",
                    });
                  } catch (e: any) {
                    toast.error(e);
                  } finally {
                    setLoading(false);
                    setShowModal(false);
                    refresh();
                  }
                }}
              />
            </div>
          }
        </div>
      </div>
    );
  };

  return (
    <div className=" px-2 py-4  rounded-[10px] border border-gray-300  flex justify-between ">
      <div>
        <p className="font-semibold text-bluegray700 ">{item.title}</p>
        <p className=" flex text-sm font-light">
          {/* names of employess */}
          {item.target == "organization" && (
            <>
              {selectedOrgEmployees
                .filter((k: any, key: number) => key < 2)
                .map((item: any, key: number) => (
                  <span>
                    {" "}
                    {` ${item?.firstName}  ${item.lastName}  ${
                      key != 1 ? " , " : " + "
                    }`}
                  </span>
                ))}
              {` ${
                selectedOrgEmployees.length > 2
                  ? selectedOrgEmployees.length - 2
                  : ""
              } Others`}
            </>
          )}
          {item.target == "position" && (
            <>
              {selectedOrgEmployees
                .filter(
                  (k: any, key: number) => k.positionID == item.positionID
                )
                .filter((i: any, key: number) => key < 2)
                .map((item: any, key: number) => (
                  <span>
                    {` ${item?.firstName}  ${item.lastName}  ${
                      key != 1 ? ", " : " + "
                    }`}
                  </span>
                ))}
              {` ${
                selectedOrgEmployees.length > 2
                  ? selectedOrgEmployees.length - 2
                  : ""
              } Others`}
            </>
          )}
          {item.target == "dept" && (
            <>
              {selectedOrgEmployees
                .filter((k: any, key: number) => k.deptID == item.deptID)
                .filter((i: any, key: number) => key < 2)
                .map((item: any, key: number) => (
                  <span>
                    {` ${item?.firstName}  ${item?.lastName}  ${
                      key < 1 ? ", " : " + "
                    }`}
                  </span>
                ))}
              {` ${
                selectedOrgEmployees.length > 2
                  ? selectedOrgEmployees.length - 2
                  : ""
              } Others `}
            </>
          )}
          {item.target == "employee" && (
            <>
              {selectedOrgEmployees
                .filter((k: any, key: number) => k.id == item.employeeID)
                .map((item: any, key: number) => (
                  <span> {` ${item?.firstName}  ${item.lastName}`}</span>
                ))}
            </>
          )}
        </p>
        <div className="flex text-bluegray700 justify-center items-center">
          <p className="text-xs font-semiboldx">
            <FaCalendar size={15} className=" inline mr-1" />
            {new Date(item.deadlineDate).toDateString()}
          </p>
          <p className="text-xs  capitalize font-light">
            <BsPersonCheck
              size={15}
              className="inline m-1 bg-bluegray700 text-white p-.5 rounded"
            />
            {item.target}
          </p>
          <p className="text-xs font-light">
          <GoDotFill
            size={15}
            className={`${
              item.status.includes("Pending") || item.status.includes("Cancel")
                ? "text-[#F79009]"
                : ""
            }  ${item.status.includes("In-Progress") ? "text-blue-400" : ""}  ${
              item.status.includes("Completed") ? "text-green-400" : ""
            } inline `}
          />
            {item.status}
          </p>
        </div>
      </div>
      <Menu as="div" className={`relative my-2 `}>
        <Menu.Button className="   w-full  ">
          <IoMdMore size={20} className="text-bluegray700 " />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            onClick={() => {}}
            className="origin-top-left z-10 absolute right-0 mt-2 rounded-sm shadow-md p-1 bg-white w-full  max-h-[200px] min-w-[150px]   overflow-x-hidden overflow-y-scroll ring-1 ring-black ring-opacity-5 focus:outline-none"
          >
            <Menu.Item>
              <p
                onClick={() => {
                  showModal("", "", <> </>, <ViewApprModal />);
                }}
                className=" text-xs font-light w-full text-black p-3 m-2 cursor-pointer truncate hover:bg-customGray "
              >
                <IoMdEye className="inline" /> View
              </p>
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
